import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=57683b5c&"
import script from "./PatientDetail.vue?vue&type=script&lang=ts&"
export * from "./PatientDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports